export enum PaginationDirection {
  next = "next",
  previous = "previous",
  current = "current",
}

export interface Pagination {
  [key: string]: {
    direction: PaginationDirection;
  };
}

export interface SetPaginationDirection {
  resource: string;
  direction: PaginationDirection;
}
